export default [
  { value: 'week', name: 'Weekly' },
  { value: 'fortnight', name: 'Every Fortnight' },
  { value: 'month', name: 'Monthly' },
  { value: 'quarter', name: 'Quarterly' },
  { value: 'never', name: 'Never' }
]
